const windowSize = {
    state:{
        screenWidth:document.documentElement.clientWidth,
        screenHeight:document.documentElement.clientHeight
    }
}

export default windowSize;